import { UpdatePasswordWithTokenMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const UpdatePasswordMutationHandler =
  graphql.mutation<UpdatePasswordWithTokenMutation>(
    "updatePasswordWithToken",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: { updatePasswordWithToken: true },
      });
    }
  );
